module.exports = __webpack_public_path__ + "img/vr-button.44e71b87.svg";